'use client'
import { FC } from 'react'
import { Button, ButtonProps } from '@/root/ui/tuuleliinid'
import { BottomArrowIcon } from '@/root/ui/shared'
import { useCustomRouter, useGetTranslations } from '@/root/shared-hooks'
import { getSelectTicketsPath } from '@/root/modules/shared/SelectDateTimePage'
import { testIds } from '@/root/shared-consts'

interface SelectTicketButtonProps extends ButtonProps {
  packages: Array<string>
  sailRefIds: Array<number>
}

export const SelectTicketButton: FC<SelectTicketButtonProps> = ({ disabled, packages, sailRefIds }) => {
  const { locale, push } = useCustomRouter()
  const { getTranslation } = useGetTranslations()

  const onGoToSelectTicket = () => push(getSelectTicketsPath(locale, packages, sailRefIds))

  return (
    <Button
      variant="gray"
      className="flex h-20 w-1/2 max-w-64 items-center justify-between px-4"
      disabled={disabled}
      onClick={onGoToSelectTicket}
      data-testid={testIds.sailSelect.goToNext}
    >
      <div className="text-left">
        <div className="xxs:text-2xl/7 text-xl uppercase">{getTranslation('continueLabel')}</div>
        <div className="text-sm">{getTranslation('selectTicketLabel')}</div>
      </div>
      <div className="mt-2.5 size-6">
        <BottomArrowIcon color="white" width={16} ignoreRtl className="ltr:-rotate-90" />
      </div>
    </Button>
  )
}
